import * as OvationsApi from 'core/ovations-api';
import { range } from 'lodash';

const batchTypeEnumCount = Object.keys(OvationsApi.Enums.BatchType).length / 2;
const batchJobTypeEnumCount = Object.keys(OvationsApi.Enums.BatchJobType).length / 2;

export const mockBatchConfigurationList: OvationsApi.Types.BatchConfiguration[] = range(0, 7).map((i) => ({
    id: i + 1,
    programId: '_programId_',
    name: `_name_${i}`,
    batchType: OvationsApi.Enums.BatchType[i % batchTypeEnumCount] as OvationsApi.Enums.BatchType,
    jobType: OvationsApi.Enums.BatchStatus[i % batchJobTypeEnumCount] as OvationsApi.Enums.BatchJobType,
    isArchived: false,
    startDate: `2018-0${i}-01T20:00:08.734Z`,
}));

export const mockBatchConfiguration = mockBatchConfigurationList[0];
